let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cJ6Y5")).then(() => parcelRequire('40GI8'));